import React from "react";
import { Tag, Check, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const DiscountField = ({ code, setCode, onApply, checking, discount }) => (
  <div className="mt-8">
    <label className="text-sm font-semibold text-black/70">Κωδικός έκπτωσης (προαιρετικό)</label>
    <div className="mt-3 flex gap-3">
      <div className="relative flex-1">
        <Tag className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-black/40" />
        <Input
          data-testid="calculator-discount-input"
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="Εισάγετε Κωδικό"
          className="pl-9 uppercase"
        />
      </div>
      <Button
        type="button"
        data-testid="calculator-apply-discount"
        onClick={onApply}
        disabled={checking}
        variant="outline"
        className="h-10 rounded-xl border-black/15 px-5 font-semibold"
      >
        {checking ? <Loader2 className="h-4 w-4 animate-spin" /> : "Εφαρμογή"}
      </Button>
    </div>
    {discount && (
      <p className="mt-2 flex items-center gap-1.5 text-sm font-medium text-brand-500">
        <Check className="h-4 w-4" /> {discount.label || `-${discount.percent}%`} (κωδικός {discount.code})
      </p>
    )}
  </div>
);
